/** Planning duration helpers (value + unit). Compatible with legacy montagedagen-only rows. */

export const PLANNING_DURATION_UNITS = ['minutes', 'hours', 'half_day', 'days'];

export function defaultSidebarDuration(order) {
  const unit = String(order?.planning_duration_unit || '').trim().toLowerCase();
  const value = Number(order?.planning_duration_value);
  if (unit && PLANNING_DURATION_UNITS.includes(unit) && Number.isFinite(value) && value > 0) {
    return { value, unit };
  }
  const days = Math.max(Number(order?.montagedagen || 0), 1);
  return { value: days, unit: 'days' };
}

/** Weekday span for calendar cards (same rules as backend). */
export function getPlanningWeekdaySpan(order) {
  const unit = String(order?.planning_duration_unit || '').trim().toLowerCase();
  const value = Number(order?.planning_duration_value);
  if (unit && PLANNING_DURATION_UNITS.includes(unit) && Number.isFinite(value) && value > 0) {
    if (unit === 'days') return Math.max(Math.ceil(value), 1);
    return 1;
  }
  return Math.max(Number(order?.montagedagen || 0), 1);
}

/** Short label for calendar cards / search chips; null when nothing extra to show. */
export function formatPlanningDurationLabel(order, t) {
  const unit = String(order?.planning_duration_unit || '').trim().toLowerCase();
  const value = Number(order?.planning_duration_value);
  if (unit && PLANNING_DURATION_UNITS.includes(unit) && Number.isFinite(value) && value > 0) {
    if (unit === 'minutes') {
      const n = Math.round(value);
      return `${n} ${n === 1 ? t('planningDurationMinute') : t('planningDurationMinutes')}`;
    }
    if (unit === 'hours') {
      const label = Number.isInteger(value) ? String(value) : String(value);
      return `${label} ${value === 1 ? t('planningDurationHour') : t('planningDurationHours')}`;
    }
    if (unit === 'half_day') {
      return t('planningDurationHalfDay');
    }
    const days = Math.max(Math.ceil(value), 1);
    return `${days} ${days === 1 ? t('planningWorkday') : t('planningWorkdays')}`;
  }
  const days = Number(order?.montagedagen || 0);
  if (days > 1) return `${days} ${t('planningWorkdays')}`;
  return null;
}

export function weekdaySpanFromDuration(value, unit) {
  const u = String(unit || '').trim().toLowerCase();
  const v = Number(value);
  if (!Number.isFinite(v) || v <= 0) return 1;
  if (u === 'days') return Math.max(Math.ceil(v), 1);
  return 1;
}
